import { Activity } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip'

interface FrenteServico {
  nome: string
  obraNome: string
  ultimoRegistro: string
  diasParado: number
}

interface Props {
  frentes: FrenteServico[]
}

export default function DashboardOperacional({ frentes }: Props) {
  const ativas = frentes.filter(f => f.diasParado <= 3)
  const paradas = frentes.filter(f => f.diasParado > 3)

  return (
    <TooltipProvider>
      <div className="rounded-xl p-4 border" style={{ background: 'hsl(var(--bg2))', borderColor: 'hsl(var(--line))' }}>
        <div className="flex items-center gap-2 mb-4">
          <Activity size={14} className="text-primary" />
          <span className="text-sm font-bold text-foreground">Produtividade por Frente (7 dias)</span>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="text-[10px] text-muted-foreground cursor-help ml-1">ⓘ</span>
            </TooltipTrigger>
            <TooltipContent><p className="text-xs max-w-[200px]">Frentes de serviço baseadas nos RDOs dos últimos 7 dias. Frentes sem registro há 3+ dias são destacadas.</p></TooltipContent>
          </Tooltip>
        </div>

        {frentes.length === 0 ? (
          <p className="text-xs text-muted-foreground text-center py-4">Sem dados de frentes de serviço</p>
        ) : (
          <div className="space-y-1.5 max-h-[260px] overflow-y-auto">
            {paradas.length > 0 && (
              <>
                <div className="text-[10px] font-bold uppercase tracking-wider mb-1" style={{ color: 'hsl(var(--rose))' }}>
                  ⚠ Paradas há 3+ dias ({paradas.length})
                </div>
                {paradas.map((f, i) => (
                  <div key={`p-${i}`} className="flex items-center gap-2 px-2 py-1.5 rounded-lg" style={{ background: 'hsl(var(--rose) / 0.06)' }}>
                    <div className="w-2 h-2 rounded-full" style={{ background: 'hsl(var(--rose))' }} />
                    <span className="text-xs text-foreground truncate flex-1">{f.nome}</span>
                    <span className="text-[10px] text-muted-foreground">{f.obraNome}</span>
                    <span className="text-[10px] font-bold" style={{ color: 'hsl(var(--rose))' }}>{f.diasParado}d</span>
                  </div>
                ))}
              </>
            )}
            {ativas.length > 0 && (
              <>
                <div className="text-[10px] font-bold text-muted-foreground uppercase tracking-wider mb-1 mt-2">
                  ✓ Ativas ({ativas.length})
                </div>
                {ativas.map((f, i) => (
                  <div key={`a-${i}`} className="flex items-center gap-2 px-2 py-1.5 rounded-lg" style={{ background: 'hsl(var(--bg3))' }}>
                    <div className="w-2 h-2 rounded-full" style={{ background: 'hsl(var(--emerald))' }} />
                    <span className="text-xs text-foreground truncate flex-1">{f.nome}</span>
                    <span className="text-[10px] text-muted-foreground">{f.obraNome}</span>
                    <span className="text-[10px] font-bold" style={{ color: 'hsl(var(--emerald))' }}>
                      {f.diasParado === 0 ? 'Hoje' : `${f.diasParado}d`}
                    </span>
                  </div>
                ))}
              </>
            )}
          </div>
        )}
      </div>
    </TooltipProvider>
  )
}
